<template>
    <div>
        <p>找不到此頁面，請確認是否為有效網址。</p>
    </div>
</template>
<script>
export default {
};
</script>
